import React, { useState } from 'react';
import styled from 'styled-components';
import SidebarGuest from '../Guest/SidebarGuest'; 
import NavbarGuest from '../Guest/NavbarGuest'; 
import HomeGuest from '../Guest/HomeGuest'; 
import AboutAdmin from '../Admin/AboutAdmin';
import HelpGuest from '../Guest/HelpGuest';
import Chatbot from '../Components/Chatbot';

import ProfileModal from '../Components/Profile';

const Dashboard = () => {
  const [selectedContent, setSelectedContent] = useState('HomeGuest'); 
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false); 

  const handleNavClick = (item) => {
    setSelectedContent(item);  
  };

  const handleSidebarToggle = (expanded) => {
    setIsSidebarExpanded(expanded);
  };

  const renderContent = () => {
    switch (selectedContent) {
      case 'HomeGuest': 
        return <HomeGuest />;
        
      case 'AboutAdmin':
        return <AboutAdmin />;

        case 'HelpGuest':
          return <HelpGuest />;
  
      case 'ProfileModal':
        return <ProfileModal />;

        default:
        return <HomeGuest />;
    }
  };

 

  return (
    <DashboardContainer> 

<NavbarGuest onSelect={handleNavClick} />
<SidebarGuest
        onSelect={handleNavClick}
        selectedContent={selectedContent}
        onToggleSidebar={handleSidebarToggle} // NEW
      />
      <Content isExpanded={isSidebarExpanded}>
      {renderContent()}
      </Content>
      <Chatbot />
    </DashboardContainer>
  );
};

export default Dashboard;

const DashboardContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  position: relative; 
   overflow: hidden;
`;

const Content = styled.div`
  flex-grow: 1;
  margin-left: ${({ isExpanded }) => (isExpanded ? '1px' : '0px')};
  transition: margin-left 0.1s ease;
  padding: 2px;
`;

